import { Component } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap/lib';
import classNames from 'classnames';

class DashboardHeader extends Component {

    constructor(...args) {
        super(...args);
        this.state = {
            selectedTeamName: '',
            selectedCellName: ''
        };
    }

    handleTextChangeTeam(teamDetails) {
        this.state.selectedTeamName = teamDetails.teamName ? teamDetails.teamName : '';
        const { fetchTicketTechData, refresh, changeOwnerTeam } = this.props;
        changeOwnerTeam(teamDetails.teamId);
        fetchTicketTechData();
        refresh();
    }

    handleTextChangeCell(cellDetails) {
        const { fetchTicketTechData, refresh, changeCell } = this.props;
        changeCell(cellDetails.cellId);
        fetchTicketTechData();
        refresh();
    }

    render() {
        const { OwnerTeamData, UserDetails, CellData } = this.props;
        const className = classNames(
            OwnerTeamData.length > 1 ? 'form-control ttd-page-header__team-selection' : 'hide'
        );
        const classNameLabel = classNames(
            OwnerTeamData.length > 1 ? 'hide' : 'header-label'
        );

        const team = OwnerTeamData.find(teamData => teamData.NocTeamId === UserDetails.OwnerTeamId);

        if (team) {
            this.state.selectedTeamName = team.NocTeamName;
        }

        const cell = CellData.find(cellData => cellData.CellId === UserDetails.CellId);
        if (cell) {
            this.state.selectedCellName = cell.CellName;
        }

        return (
            <div className="ttd-page-header">
                <h1>
                    <strong className="ttd-page-header__text">
                        TICKET TRACKING DASHBOARD
                    </strong>

                    <DropdownButton
                        bsStyle={'Default'.toLowerCase()}
                        title={this.state.selectedTeamName}
                        key={1}
                        id={`team-selection-${1}`}
                        className={className}
                        onSelect={teamDetails => { this.handleTextChangeTeam(teamDetails); }}
                    >
                        {
                            OwnerTeamData.map((NocTeam, Id) => {
                                const teamDetails = {
                                    teamId: NocTeam.NocTeamId,
                                    teamName: NocTeam.NocTeamName
                                };
                                return (
                                    <MenuItem
                                        eventKey={teamDetails} key={Id}
                                        value={NocTeam.NocTeamId}
                                    >
                                        { NocTeam.NocTeamName }
                                    </MenuItem>
                                );
                            })
                        }
                    </DropdownButton>

                    {OwnerTeamData.map((NocTeam, Id) => {
                        return (
                            <label key={Id} className={classNameLabel}>
                                {NocTeam.NocTeamName}
                            </label>
                        );
                    })}

                    <DropdownButton
                        title={this.state.selectedCellName}
                        bsStyle={'Default'.toLowerCase()}
                        className="ttd-page-header__cell-selection"
                        id={`cell-selection-${1}`}
                        onSelect={cellDetails => { this.handleTextChangeCell(cellDetails); }}
                    >
                        {
                            CellData.map((CellTeam, Id) => {
                                const cellDetails = {
                                    cellId: CellTeam.CellId,
                                    cellName: CellTeam.CellName
                                };
                                return (
                                    <MenuItem
                                        eventKey={cellDetails} key={Id}
                                        value={CellTeam.CellId}
                                    >
                                        { CellTeam.CellName }
                                    </MenuItem>
                                );
                            })
                        }
                    </DropdownButton>

                </h1>
            </div>
        );
    }
}

export default DashboardHeader;



// WEBPACK FOOTER //
// ./app/tickets/components/DashboardHeader.jsx